<template>
  <div class="ls-no-padding">
    <div class="col-md-8 col-lg-7 col-sm-6 ls-lg-margin-top">

      <h3 class="ls-sm-margin-bottom">{{ $t('payments.labels.yapay_account')}}</h3>
      <h5 class="ls-md-margin-top ls-lg-margin-bottom">{{ $t('payments.labels.do_login_to_continue') }}</h5>
      <form class="ls-form" @submit.prevent="validateBeforeSubmit">

        <MaterialInput
          type="email"
          label="Email"
          ref="email"
          ico="fa fa-envelope-o"
          focused="true"
          data-vv-name="email"
          v-validate="'required|email'"
          v-model="email"
          :class="{ 'material--active material--has-errors': errors.has('email') }"
          :has-error="errors.has('email')">
            {{ $t('subscribe.attributes.email') }}
            <small class="material-errors" slot="help-message" v-if="errors.has('email')">{{ errors.first('email') }}</small>
            <i class="fa fa-check" slot="ico-check" aria-hidden="true" v-if="!errors.has('email') && email"></i>
        </MaterialInput>

        <MaterialInput
          type="password"
          ico="fa fa-lock"
          label="Password"
          v-model="password"
          v-validate="'required|min:6'"
          :class="{ 'material--active material--has-errors': errors.has($t('subscribe.attributes.password')) }"
          :data-vv-name="$t('subscribe.attributes.password')">
            {{ $t('subscribe.attributes.password') }}
            <small class="material-errors" slot="help-message" v-if="errors.has($t('subscribe.attributes.password'))">{{ errors.first($t('subscribe.attributes.password')) }}</small>
            <i class="fa fa-check" slot="ico-check" v-if="!errors.has($t('subscribe.attributes.password')) && password.length" aria-hidden="true"></i>
        </MaterialInput>

        <div class="col-md-5 col-xs-12 col-lg-7 ls-float-right ls-no-padding-right">
          <button class="btn ls-btn-primary ls-sm-margin-bottom ls-float-right"><i class="fa fa-sign-in" aria-hidden="true"></i><span class="ls-xs-margin-left">{{ $t('application.button.enter')}}</span></button>
        </div>

      </form>
    </div>
    <div class="col-md-4 col-lg-offset-1 col-lg-4 col-sm-6 ls-no-padding-left ls-lg-margin-top lg-margin-top">
      <div class="full-height ls-no-padding-left ls-no-padding-right">
        <invoice-details :invoice="invoice"></invoice-details>
      </div>
    </div>
  </div>
</template>
<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import InvoiceDetails from './components/InvoiceDetails.vue'
    import MaterialInput from '../../components/shareds/MaterialInput.vue'

    export default {
      name: 'Yapay',
      components: { InvoiceDetails, MaterialInput },
      data () {
        return {
          email: '',
          password: ''
        }
      },
      methods: {
        ...mapActions(['getYapayBalance']),
        ...mapMutations(['addFlash', 'clearFlash']),
        validateBeforeSubmit () {
          this.$loader.show()
          this.clearFlash()
          this.$validator.validateAll().then(this.afterValidate)
        },
        afterValidate () {
          let params = { id: this.invoice.customer_id, email_yapay: this.email, password_yapay: this.password }
          this.getYapayBalance(params).then(this.afterGetBalance)
        },
        afterGetBalance (response) {
          if (response && response.status === 200) {
            this.loadCheckoutYapay()
          }
          this.$loader.hide()
        },
        loadCheckoutYapay () {
          this.$parent.loadCheckoutYapay()
        }
      },
      computed: {
        ...mapGetters(['invoice', 'yapayData'])
      },
      mounted () {
        if (this.yapayData && this.yapayData !== '') {
          this.loadCheckoutYapay()
        }
      }
    }
</script>
<style>
  @media (max-width: 767px)
  {
    .lg-margin-top {
      margin-top: 90px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// LoginYapay.vue?1b1f9613